import React from 'react';
import { Links, LinksProps } from '@att-bit/duc.components.links';
import { LinksVariant } from '@att-bit/duc.components.links';

export type LegalProps = {
  /**  children (text/jsx) to be rendered in component  */
  children: React.ReactNode,
  /**  Props for the long legal link  */
  linkProps?: LinksProps;
  /**  Legal color for onDark or not */
  variant?: LegalVariant;
  /**  Additional classes  */
  className?: string;
  /**  Sets "data-testid" attribute of the container  */
  testId?: string,
  /**  Add implicit font class type-legal by default  */
  addImplicitFontClass?: boolean,
};

export enum LegalVariant {
  ON_DARK = "color-gray-400",
  default = "",
}

export function Legal({
  children,
  linkProps,
  variant = LegalVariant.default,
  addImplicitFontClass = true,
  ...props
}: LegalProps) {
  
  return (                 
    <div data-testid={props.testId} className={`${variant}  ${addImplicitFontClass ? "type-legal" : "type-xs line-h-base"} ${props.className ? props.className : ''}`}>
        {children} 
        {linkProps && (
            <span className="mar-l-xxxs">
                <Links {...linkProps} variant={LinksVariant.none}/>
            </span>
        )}
    </div>
  );
}